import { AssessmentType } from "../../../types/Assessment";
import { post } from "../../../utils/axios-config";
import { ASSESSMENTS } from "../../../utils/constants";

export const createAssessment = async (data: AssessmentType) => await post<AssessmentType, string>(ASSESSMENTS, data);